import * as api from "../../api/index";


export const getserviceCardData =  async(assetId:string, serviceType:string) => {
    try{
     return await api.getServiceCard(assetId, serviceType)
    }catch(e:any){
      return (e)
    }
  }

  